import {apiConfig, appConfig} from '@stencil/hotels-config';

import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';

const {defaultFlavour, defaultRoomString} = appConfig;

const {hermesSegmentSliderApiConfig, __HERMES__} = apiConfig;

const prepareSegmentSliderApiRequest = ({
  checkin,
  checkout,
  roomString = defaultRoomString,
  hctx = '',
  cityId = '',
}) => {
  let url = `${__HERMES__}`;

  const checkinDateForHermes = parseDateIntoHermesString(checkin.date);
  const checkoutDateForHermes = parseDateIntoHermesString(checkout.date);

  url += `/hotels/${hermesSegmentSliderApiConfig.version}/collection/data/${defaultFlavour}/${checkinDateForHermes}/${checkoutDateForHermes}/${roomString}`;

  if (cityId && hctx) {
    url += `?hctx=${hctx}&vcid=${cityId}`;
  } else if (hctx) {
    url += `?hctx=${hctx}`;
  }
  return url;
};

export default prepareSegmentSliderApiRequest;
